(function () {
  'use strict';

  function visibleOptionRadios(fieldset) {
    return Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]:not([data-decide-later-input="true"])')).filter(function (radio) {
      if (!radio || radio.disabled) return false;

      var wrap = radio.closest('.block-color-texture-card__color-item, .block-color-texture-card__texture-item, .color-dependent-option');
      if (wrap && (wrap.hidden || wrap.style.display === 'none' || wrap.classList.contains('hidden'))) return false;

      if (wrap && (wrap.classList.contains('block-color-texture-card__texture-item') || wrap.classList.contains('color-dependent-option'))) {
        return wrap.classList.contains('is-visible') && wrap.style.display !== 'none';
      }

      return radio.style.display !== 'none' && !radio.hidden;
    });
  }

  function selectSingleOptions(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-color-texture-card]')).forEach(function (card) {
      if (card.getAttribute('data-user-decided-later') === 'true') return;

      Array.prototype.slice.call(card.querySelectorAll('fieldset')).forEach(function (fieldset) {
        if (
          card.getAttribute('data-user-deselected-single-texture') === 'true' &&
          fieldset.matches('.block-color-texture-card__texture-fieldset, [data-texture-area]')
        ) {
          return;
        }

        var radios = visibleOptionRadios(fieldset);
        if (radios.length !== 1 || radios[0].checked) return;

        var decideLater = card.querySelector('[data-decide-later-input="true"]');
        if (decideLater) {
          decideLater.checked = false;
          decideLater.removeAttribute('checked');
        }

        radios[0].checked = true;
        radios[0].setAttribute('checked', 'checked');
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function scheduleSingleOptionSelect(root) {
    [0, 50, 150, 400, 900, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        selectSingleOptions(root || document);
      }, delay);
    });
  }

  window.CustomDecideLaterSelect = function (label) {
    if (!label || !label.htmlFor) return true;

    var input = document.getElementById(label.htmlFor);
    if (!input) return true;
    var card = input.closest ? input.closest('[data-color-texture-card]') : null;

    if (input.checked) {
      if (card) {
        card.removeAttribute('data-user-decided-later');
      }

      if (
        window.CustomColorTextureControls &&
        typeof window.CustomColorTextureControls.uncheckToggleableRadio === 'function'
      ) {
        window.CustomColorTextureControls.uncheckToggleableRadio(input);
      } else {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      return false;
    }

    if (card) {
      card.setAttribute('data-user-decided-later', 'true');
      card.querySelectorAll('.block-color-texture-card__color-fieldset input[type="radio"]:checked').forEach(function (radio) {
        radio.checked = false;
        radio.removeAttribute('checked');
      });
    }

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return false;
  };

  function clearRequiredErrorIfValid(card) {
    if (!card) return;

    var errorEl = card.querySelector('[data-color-texture-required-error]');
    if (!errorEl || errorEl.classList.contains('hidden')) return;

    var decidedLater = card.getAttribute('data-user-decided-later') === 'true';
    var hasColorSelected = !!card.querySelector('.block-color-texture-card__color-fieldset input[type="radio"]:checked');
    var textureFieldset = card.querySelector('.block-color-texture-card__texture-fieldset, [data-texture-area]');
    var visibleTextureRadios = textureFieldset ? visibleOptionRadios(textureFieldset) : [];
    var hasTextureSelected = !visibleTextureRadios.length || visibleTextureRadios.some(function (radio) { return radio.checked; });

    if (decidedLater || (hasColorSelected && hasTextureSelected)) {
      errorEl.classList.add('hidden');
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('block-color-texture-card__input')) return;

    var card = input.closest('[data-color-texture-card]');
    // Run after color-change/visibility-toggle handlers settle the texture grid's display state.
    window.setTimeout(function () {
      clearRequiredErrorIfValid(card);
    }, 0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSingleOptionSelect(document);
  });

  window.addEventListener('load', function () {
    scheduleSingleOptionSelect(document);
  });

  window.addEventListener('pageshow', function () {
    scheduleSingleOptionSelect(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleSingleOptionSelect(event.target || document);
  });

  document.addEventListener('variant:change', function (event) {
    scheduleSingleOptionSelect(event.target || document);
  });

  document.addEventListener('product:variant-change', function (event) {
    scheduleSingleOptionSelect(event.target || document);
  });

  scheduleSingleOptionSelect(document);
})();
